module.exports = __webpack_public_path__ + "static/img/caoyuan.a653742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caoyuan.png
// module id = jct3
// module chunks = 1